import { DOCS_URL } from "../../../config/constants.js";
import Iframe from "./Iframe.svelte";

export default {
    component: Iframe,
    name: "Iframe",
    description: "Embed an Iframe.",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-iframe--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/border-sides.svg",
    screenshot: "",
    inputs: [
        {
            friendlyName: "Iframe Code",
            name: "iframeCode",
            type: "longText",
            required: true,
            helperText:
                "The Iframe code to embed. Don't forget to add a title to the Iframe for accessibility reasons.",
        },
        {
            friendlyName: "Desktop aspect ratio",
            name: "aspectRatio",
            type: "text",
            defaultValue: "16/9",
        },
        {
            friendlyName: "Mobile aspect ratio",
            name: "aspectRatioMobile",
            type: "text",
            defaultValue: "1/2",
        },
        {
            friendlyName: "Iframe Code - Mobile",
            name: "iframeCodeMobile",
            type: "longText",
            helperText:
                "Optional. If not provided, the desktop code will be used. Don't forget to add a title to the Iframe for accessibility reasons.",
        },
    ],
};
